/* eslint-disable react/no-danger */
/**
 * Loan
 * 
 * @Author: Focci
 * @Date: 2023-08-07 10:15:58
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 10:15:58
 */

'use client'

import PropTypes from 'prop-types'
import useLazyComponent from '@hook/useLazyComponent'
import clsx from 'clsx'
import Advert from '@comp/page/common/ad'
import Tab from '@comp/Tab'
import useTracking from '@hook/useTracking'
import { houseSearchType } from '@lib/config'
import { useTranslations } from 'next-intl'
import { Waypoint } from 'react-waypoint'
import { useCallback, useMemo, useState } from 'react'
import { isAU } from '@lib/utils'
import { getPrice, getPriceBold } from './lib'
import PropertyItemScoff from '../PropertyItemScoff'

function LoanPromotion() {
  return (
    <div className="w-[10rem] h-12 -mb-5">
      <Advert 
        locationId={2084}
        width={200}
        height={60}
      />
    </div>
  )
}

function LoanTitle({
  value,
  onChange = () => {}
}) {
  const th = useTranslations('house')
  const tsd = useTranslations('stampDuty')
  const loanTitleOptions = useMemo(() => [
    { label: th('loan'), value: 'loan' },
    { label: tsd('stampDuty'), value: 'stampDuty' },
  ], [th, tsd])

  if(!isAU) {
    return th('loan')
  }

  return (
    <Tab 
      options={loanTitleOptions}
      value={value}
      onChange={onChange}
      activeSign={<span />}
    />
  )
}

export default function Loan({
  house = {}
}) {
  const th = useTranslations('house')
  const { pushTrackListingClick } = useTracking()

  const price = house.type === houseSearchType.commercialForSale
    ? getPriceBold(house)
    : getPrice(house)
  
  const { Wedget: LoanBody, getWedget, ready } = useLazyComponent()
  const { Wedget: StampDuty, getWedget: getStampDuty } = useLazyComponent()
  const [tab, setTab] = useState('loan')

  const handleEnter = useCallback(() => {
    getWedget(() => import('./LoanBody'))
    isAU && getStampDuty(() => import('@comp/stamp-duty-calc'))
  }, [getWedget, getStampDuty])

  return (
    <PropertyItemScoff
      title={<LoanTitle value={tab} onChange={({ value }) => setTab(value)} />}
      moduleName={th('loan')}
      id="module-loan"
      action={ready ? <LoanPromotion /> : null}
    >
      <Waypoint onEnter={handleEnter}>
        <div className={clsx([tab === 'loan' && 'min-h-[579px]', !ready && 'bg-cf0'])}>
          {tab === 'stampDuty' && (<StampDuty price={price} type={house.stateId} />)}
          {tab === 'loan' && (
            <LoanBody 
              price={price}
              // loanParams={house.loanParams}
              onNewScheme={() => pushTrackListingClick('mortgage-add_calculation', house)}
            />
          )}
        </div>
      </Waypoint>
    </PropertyItemScoff>
  )
}

Loan.propTypes = {
  house: PropTypes.object,
}
